import type React from 'react';
import { useTranslations } from '@vocab/react';
import translations from './.vocab';
import type { IJob } from 'src/stores/JobStore/Job';
import { observer } from 'mobx-react';

interface Props {
  job: IJob;
}

export const JobTitleHeadingContent: React.FC<Props> = observer(({ job }) => {
  const { t } = useTranslations(translations);
  return (
    <>
      {job.isExpired && t('Expired:', { title: job.jobInformation.title })}
      {job.isPending && t('Pending:', { title: job.jobInformation.title })}
      {!job.isExpired && !job.isPending && job.jobInformation.title}
    </>
  );
});
